import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { tv as t } from "tailwind-variants";
import s from "./Bubble.js";
const m = t({
  base: [
    "gap-3",
    "inline-flex",
    "items-center",
    "justify-center",
    "*:bg-cyan-500",
    "*:w-3"
  ]
}), _ = ({ className: a }) => /* @__PURE__ */ i("div", { className: m({ class: a }), "data-testid": "loader", children: [
  /* @__PURE__ */ e(s, { className: "animate-[pulse_1s_ease_0ms_infinite]" }),
  /* @__PURE__ */ e(s, { className: "animate-[pulse_1s_ease_250ms_infinite]" }),
  /* @__PURE__ */ e(s, { className: "animate-[pulse_1s_ease_500ms_infinite]" })
] });
export {
  _ as default
};
